<script lang="ts">
    import Typeahead from "$lib/components/Typeahead.svelte";
    import {availableTags, storeTag} from "$lib/calls/tag";
    import {onMount} from "svelte";
    import {Input, Label, Spinner} from "flowbite-svelte";

    export let project;

let tags;
onMount(()=>{
    if(typeof project.tags === 'undefined'){
        project.tags = [];

    }

    if(typeof project.store === 'undefined'){
        project.store = [{
            identityKey: 'guests',
            value: 0
        }]
    }
})
    let tagPromise = availableTags()
const saveTag = async (identifier, name) => {
    const newTag = await storeTag(identifier, name);
    tagPromise = availableTags()
}

const handleProjectTag = (identifier, selected) => {
    const thisTag = project.tags.findIndex(x => x.identifier === identifier);
    if(thisTag !== -1){
        project.tags[thisTag] = selected
    } else {
        project.tags = [...project.tags, selected]
    }

}

</script>
{#await tagPromise}
    <div class="text-center my-5">
        <Spinner/>
    </div>
{:then tags}
    <h3 class="text-2xl  leading-7 text-neutral-600 mb-3 mt-4">Weitere Informationen</h3>
    <div class="grid grid-cols-2 gap-3">
        <div>
            <Typeahead
                    icon="{'la-utensils'}"
                    value={project.tags[project.tags.findIndex(x => x.identifier === 'category')]?.name}
                    label="Kategorie" data={tags.filter(x => x.identifier === 'category')} extract={selected => handleProjectTag('category', selected)}
                    let:item let:value>

                <svelte:fragment slot="no-results">
                    <div class="flex gap-3 cursor-pointer" on:keydown={ev => {if(ev.key === 'Enter') saveTag('category', value)}} on:click={() => saveTag('category', value)}>
                        <svg class="w-4 text-coolGray-500" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        <div>Kategorie "<strong>{value}</strong>" anlegen.</div>
                    </div>
                </svelte:fragment>
            </Typeahead>
        </div>
        <div>
            <Typeahead
                    icon="{'la-bullhorn'}"
                    value={project.tags[project.tags.findIndex(x => x.identifier === 'occasion')]?.name}
                    label="Anlaß" data={tags.filter(x => x.identifier === 'occasion')} extract={selected => handleProjectTag('occasion', selected)}
                    let:item let:value>

                <svelte:fragment slot="no-results">
                    <div class="flex gap-3 cursor-pointer" on:keydown={ev => {if(ev.key === 'Enter') saveTag('occasion', value)}} on:click={() => saveTag('occasion', value)}>
                        <svg class="w-4 text-coolGray-500" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        <div>Anlaß "<strong>{value}</strong>" anlegen.</div>
                    </div>
                </svelte:fragment>
            </Typeahead>
        </div>
        <div>
            <Label class="space-y-2">
                <span>Erwartete Gäste</span>
                <Input type="number" bind:value={project.store[project.store.findIndex(x => x.identityKey === 'guests')].value}>
                    <i slot="left" class="la la-users text-[24px] text-primary-400" />
                </Input>
            </Label>
        </div>

        <div>
            <Typeahead
                    icon="{'la-user-tie'}"
                    value={project.tags[project.tags.findIndex(x => x.identifier === 'outfit')]?.name}
                    label="Dresscode" data={tags.filter(x => x.identifier === 'outfit')} extract={selected => handleProjectTag('outfit', selected)}
                    let:item let:value>

                <svelte:fragment slot="no-results">
                    <div class="flex gap-3 cursor-pointer" on:keydown={ev => {if(ev.key === 'Enter') saveTag('outfit', value)}} on:click={() => saveTag('outfit', value)}>
                        <svg class="w-4 text-coolGray-500" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        <div>Dresscode "<strong>{value}</strong>" anlegen.</div>
                    </div>
                </svelte:fragment>
            </Typeahead>
        </div>

    </div>
{/await}
